export const CONFIG = {
  API_BASE_URL: (import.meta.env.VITE_API_BASE_URL as string) || "",
  WS_URL: import.meta.env.VITE_WS_URL as string,
  MOBILE_BREAKPOINT: 768,
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN as string | undefined,
  SENTRY_ENVIRONMENT:
    (import.meta.env.VITE_SENTRY_ENVIRONMENT as string) || "production",
  SENTRY_RELEASE: import.meta.env.VITE_SENTRY_RELEASE as string | undefined,
  SENTRY_TRACES_SAMPLE_RATE: Number(
    import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || "0.2",
  ),
};
